<template>
    <v-autocomplete
        v-model="facturadorId"
        variant="solo"
        :items="facturadores"
        :item-title="facturadorTitle"
        item-value="id"
        :rules="obligatorio"
        :loading="cargandoFacturadores"
        label="Facturador"
        required
        class="asterisco"
        @update:model-value="seleccionarFacturador"
    >
        <template v-slot:item="{ props, item }">
            <v-list-item v-bind="props" :subtitle="item.raw.direccion"></v-list-item>
        </template>
    </v-autocomplete>
</template>
<style src="../assets/general.css"></style>
<script>
    import { obligatorio } from '@/_helpers/rules';
    import FacturadorService from '@/api/FacturadorService';

    const facturadorService = new FacturadorService();

    export default {
        data() {
            return {
                facturadorId: null,
                facturadores: [],
                cargandoFacturadores: false,
                obligatorio : obligatorio
            }
        },
        mounted() {
            this.cargarFacturadores();
        },
        methods:{
            async cargarFacturadores() {
                this.cargandoFacturadores = true;
                const response = await facturadorService.getFacturadoresTotales();
                if(response && response.status === 200) {
                    this.facturadores = response.data;
                }
                this.cargandoFacturadores = false;
            },
            facturadorTitle(item){
                if (!item) return '';
                return `${item.cuitFacturador} - ${item.nombre}`;
            },
            seleccionarFacturador(){
                this.$emit('facturador-seleccionado', this.facturadorId);
            }
        }
    }
</script>